import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-oauth',
  templateUrl: './oauth.component.html',
  styleUrls: ['./oauth.component.scss']
})
export class OauthComponent implements OnInit {
  sts: boolean = true;
  constructor(private readonly authenticationService: AuthenticationService, private readonly modalService: NgbModal) { }
  ngOnInit() {
    this.authenticationService.login();
    this.authenticationService.currentMessage.subscribe(message => {
      this.sts = message;
      if (this.sts === false) {
      }

    });
  }
}
